export default __webpack_public_path__ + "static/media/sun.7ff451e7.svg";